import React from 'react';
import { ContentState, ContentBlock } from 'draft-js';

import './GifBlock.scss';

type Props = {
  block: ContentBlock;
  contentState: ContentState;
};

function GifBlock({ block, contentState }: Props) {
  const { src } = contentState.getEntity(block.getEntityAt(0)).getData();
  return (
    <figure className="gif-block">
      <img className="gif-block-image" src={src} alt={src} />
    </figure>
  );
}

export default GifBlock;
